export const fmtBRL = (n) => {
    const v = Number(n || 0);
    return v.toLocaleString("en-US", { style: "currency", currency: "USD" });
};

export const fmtTime = (iso) => {
    if (!iso) return "-";
    try {
        return new Date(iso).toLocaleString("en-US", { hour: "2-digit", minute: "2-digit", day: "2-digit", month: "2-digit" });
    } catch {
        return "-";
    }
};

export const elapsedFrom = (iso) => {
    if (!iso) return "-";
    const start = new Date(iso).getTime();
    const diff = Math.max(0, Date.now() - start);
    const h = Math.floor(diff / 3_600_000);
    const m = Math.floor((diff % 3_600_000) / 60_000);
    return `${h}h ${m.toString().padStart(2, "0")}m`;
};
